import type { ReactNode } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@shared-kernel/primary/shared/shadcn/ui/table";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { SearchX } from "lucide-react";
import { Skeleton } from "@shared-kernel/primary/shared/shadcn/ui/skeleton";

interface Props {
  headers: {
    classname?: string;
    title: Nullable<string | ReactNode>;
  }[];
  entries: { value: Nullable<string | number> | JSX.Element | JSX.Element[]; classname?: string }[][];
  isLoading?: boolean;
  emptyMessage: string;
}

export const SimpleTable = ({ headers, entries, isLoading = false, emptyMessage }: Props) => {
  if (isLoading) {
    return (
      <div className="w-full rounded-md border p-1">
        <Table>
          <TableHeader>
            <TableRow>
              {headers.map((h, index) => (
                <TableHead className={h.classname} key={index}>
                  {h.title}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton className="h-4 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <div className="w-full rounded-md border p-1">
      <Table>
        <TableHeader>
          <TableRow>
            {headers.map((h, index) => (
              <TableHead className={h.classname} key={index}>
                {h.title}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {entries.length > 0 ? (
            entries.map((e, index) => (
              <TableRow key={index}>
                {e.map(({ value, classname }, index) => (
                  <TableCell className={classname} key={index}>
                    {value}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={headers.length} className="h-32 text-center align-middle">
                <div className="flex flex-col items-center justify-center gap-2 text-muted-foreground">
                  <SearchX className="size-8" />
                  <p>{emptyMessage}</p>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
